/**
 * App entry flow ΓÇö Login ΓåÆ Subscription ΓåÆ Home
 */
import { isLoginComplete } from '../services/authService';
import { hasAppAccess } from './subscription.helpers';

/** Next required step, or null if flow complete for target route. */
export function getRequiredFlowStep({ isAuthenticated, access, synced, bootstrapped }) {
  if (!bootstrapped) {
    return '/login';
  }
  if (!isAuthenticated || !isLoginComplete()) {
    return '/login';
  }
  if (!synced || !hasAppAccess(access)) {
    return '/subscription';
  }
  return null;
}

export function isFlowComplete({ isAuthenticated, access, synced, bootstrapped }) {
  return getRequiredFlowStep({ isAuthenticated, access, synced, bootstrapped }) === null;
}

/** Where to send a user after login / verify / Google, once the session exists. */
export function postLoginPath(user, access) {
  if (!hasAppAccess(access)) {
    return '/subscription';
  }
  if (user && String(user.role || '').toUpperCase() === 'ADMIN') {
    return '/admin';
  }
  return '/';
}
